angular.module('smartorg.r6.mgmts.userProfile', [
    require('../../../../../../components/password/app/js/plumbing/app'),
    require('../../../../../../components/phone-number/app/js/plumbing/app'),
]);
require('./user-profile-directive');
require('../../css/app.css');
module.exports = 'smartorg.r6.mgmts.userProfile';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/user-profile/app/js/plumbing/app.js